import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';
import { Cluster } from 'src/app/models/cluster.model';
import { RiskManagementParameters } from 'src/app/models/risk-management-parameters.model';
import { RiskManagementService } from 'src/app/services/risk-management.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-risk-management',
  templateUrl: './risk-management.component.html',
  styleUrls: ['./risk-management.component.scss']
})
export class RiskManagementComponent implements OnInit, OnDestroy {

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;

  isImplementing: boolean = false;
  isInsuranceComputing: boolean = false;
  isSimulationComputing: boolean = false;
  insuranceParameters: RiskManagementParameters;
  simulationParameters: RiskManagementParameters;
  parameters: RiskManagementParameters;

  selectBlock: string = '';

  panelOpenState = false;

  constructor(private router: Router,
              private clustersService: ClustersService,
              private riskManagementService: RiskManagementService,
              private notificationsService: NotificationsService) {
  }

  ngOnInit(): void {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (currentCluster: Cluster) => {
        this.currentCluster = currentCluster;
      }
    );
    this.clustersService.emitCurrentCluster();

    // Default parameters if not specified by the parent component
    if (!this.parameters) {
      this.parameters = new RiskManagementParameters();
      this.parameters.initFromData({
        initial_capital: 100,
        aggressiveness: 'moderate',
        rebalancing_frequency: 'monthly',
        target_type: 'maximum_loss',
        protection_level: 30,
        risk_free_rate: 1,
        protection_horizon: ['one_year','three_years'][1]
      });
    }
  }

  ngOnDestroy() {
    if(this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
  }

  async onImplement() {
    this.notificationsService.runSpinner();
    this.isImplementing = true;
    this.isInsuranceComputing = true;
    this.isSimulationComputing = true;

    try {
      await this.riskManagementService.computeProtected(this.parameters, this.currentCluster, true);
      await this.clustersService.select(this.currentCluster.id);

      this.isImplementing = false;
      this.isInsuranceComputing = false;
      this.isSimulationComputing = false;
      this.notificationsService.stopSpinner();
      this.router.navigate(['/tools/analytics']);
    }
    catch(e) {
      this.notificationsService.notify('protected/create-failed');
    }

    this.isImplementing = false;
    this.isInsuranceComputing = false;
    this.isSimulationComputing = false;
    this.notificationsService.stopSpinner();
  }
}
